import { CREATE, DELETE, fetchUtils, GET_LIST, GET_ONE, UPDATE } from 'react-admin'
import { auth0, getApiUrl } from '../auth/client'
import fakeDataProvider from './fakeDataProvider'

const httpClient = async (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' })
  }
  options.headers.set('Authorization', `Bearer ${await auth0.getTokenSilently()}`)
  return fetchUtils.fetchJson(url, options)
}

const assetCustomFieldDataProvider = async (type, resource, params) => {
  const baseApiUrl = await getApiUrl()
  if (!baseApiUrl) {
    return fakeDataProvider(type, resource, params)
  }
  const apiUrl = `${baseApiUrl}/api`

  const name = params?.data?.name ? params.data.name : ''
  const scope = { globalField: params?.data?.globalField, assetTypeIds: params?.data?.assetTypeIds }

  switch (type) {
    case GET_LIST: {
      const { page, perPage } = params.pagination || { page: 1, perPage: 10 }
      const { field, order } = params.sort || { field: 'name', order: 'ASC' }

      const queryParams = `page=${page}&size=${perPage}&total=1&sort=${field}&order=${order}`

      const url = `${apiUrl}/asset/customFields?${queryParams}`
      const { headers, json } = await httpClient(url)

      const contentRange = headers.get('Content-Range')
      const total = contentRange ? parseInt(contentRange.split('/').pop(), 10) : json.length

      return {
        data: json.map((item) => ({ ...item, id: item.id, type: item.dataType })),
        total: total,
      }
    }

    case GET_ONE:
      const id = params.id
      const fetchedAssetCustomField = await httpClient(`${apiUrl}/asset/customFields/${id}`).then(
        (response) => response.json,
      )
      return {
        data: {
          ...fetchedAssetCustomField[0],
          id: fetchedAssetCustomField[0].id,
          type: fetchedAssetCustomField[0].dataType,
        },
      }

    case CREATE:
      return await fetch(`${apiUrl}/asset/customFields`, {
        method: 'post',
        body: JSON.stringify({ name, dataType: params.data.type, ...scope }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await auth0.getTokenSilently()}`,
        },
      })
        .then((response) => response.json())
        .then((data) => ({
          data: {
            id: data.id,
            name: data.name,
            type: data.dataType,
            globalField: data.globalField,
            assetTypeIds: data.assetTypeIds,
          },
        }))
        .catch((error) => {
          console.error('Error during asset creation:', error)
        })

    case UPDATE:
      return await fetch(`${apiUrl}/asset/customFields/${params.data.id}`, {
        method: 'put',
        body: JSON.stringify({ name, dataType: params.data.type, ...scope }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await auth0.getTokenSilently()}`,
        },
      })
        .then((response) => response.json())
        .then((data) => ({
          data: {
            id: data.id,
            name: data.name,
            type: data.dataType,
            globalField: data.globalField,
            assetTypeIds: data.assetTypeIds,
          },
        }))
        .catch((error) => {
          console.error('Error during asset update:', error)
        })

    case DELETE:
      return await fetch(`${apiUrl}/asset/customFields/${params.id}`, {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await auth0.getTokenSilently()}`,
        },
      })
        .then(() => ({
          data: { id: params.id },
        }))
        .catch((error) => {
          console.error('Error during asset deletion:', error)
        })
    default:
      throw new Error(`Not implemented`)
  }
}

export default assetCustomFieldDataProvider
